import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 共同作者
const co_author = new Restful(project, 'co_author')
// 稿件列表
co_author.getList = data => {
  const url = project + 'co_author/manuscript'
  return http.get(url, data).then(res => {
    return res
  })
}
// 作者确认/拒绝
co_author.confirmOrDecline = (id, data) => {
  const url = project + `co_author/manuscript/url/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}

export { co_author }
